import { API_URL } from '../../../app-config/constants';
import YourSurveys, { YourSurvey, YourSurveyAnswers } from '../../../types/YourSurveys';
import { get, post, put } from '../request';

getAll.operation = 'READ';
export function getAll(): Promise<YourSurvey[]> {
    return get<YourSurveys>(`${API_URL}/your-surveys`).then(result => result.surveys);
}

getByInstanceId.operation = 'READ';
export function getByInstanceId(surveyInstanceId: string) {
    return get<YourSurvey>(`${API_URL}/your-surveys/${surveyInstanceId}`);
}

answerSurvey.operation = 'COMMAND';
export function answerSurvey(survey: YourSurvey, answers: YourSurveyAnswers) {
    return post<YourSurvey>(`${API_URL}/your-surveys/${survey.surveyInstanceId}`, {
        postData: answers,
    });
}

submitSurvey.operation = 'COMMAND';
export function submitSurvey(survey: YourSurvey, submitted: boolean) {
    return put<YourSurvey>(`${API_URL}/your-surveys/${survey.surveyInstanceId}/submission`, {
        postData: { submitted },
    });
}
